// Source: https://github.com/sharphealthcare/sharp-com-headless/blob/main/src/hooks/use-url-hash.ts
import { useEffect, useState } from 'react'

const useUrlHash = (): string => {
  const [hash, setHash] = useState('')

  const updateHash = (str: string) => {
    if (!str) return
    
    setHash(str.split('#')[1])
  }

  // Wait until the window object is available to set the event listener for the hash change
  const windowReady = typeof window !== 'undefined'

  useEffect(() => {
    if (windowReady) {
      const onWindowHashChange = () => updateHash(window.location.hash)
      
      window.addEventListener('hashchange', onWindowHashChange)

      updateHash(window.location.hash)

      return () => {
        window.removeEventListener('hashchange', onWindowHashChange)
      }
    }
  }, [windowReady])

  return hash
}

export default useUrlHash
